module.exports = __webpack_public_path__ + "img/share-tw.da25e4e2.svg";